// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as OrderNavbar from "./OrderNavbar.bs.js";
import * as EventTracker from "../../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as EditOrderContainer from "../../../../../edit-order/view/components/EditOrderContainer.bs.js";
import * as NLOrderLeftSection from "./NLOrderLeftSection.bs.js";
import * as NLOrderRightSection from "./NLOrderRightSection.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";

function getOrderId(order_details) {
  return order_details._0.order_id;
}

function OutboundOrderDashboardCmp(Props) {
  var order_crn = Props.order_crn;
  var order_details = Props.order_details;
  var order_fare = Props.order_fare;
  var user = Props.user;
  var tickets = Props.tickets;
  var is_edit_order_open = Props.is_edit_order_open;
  var scheduled_order_data = Props.scheduled_order_data;
  var load_assist_info = Props.load_assist_info;
  var match = React.useState(function () {
        return false;
      });
  var updateEditOrderSidebar = match[1];
  var is_editorder_sidebar_open = match[0];
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var toggleEditOrderSidebar = function (param) {
    Curry._1(updateEditOrderSidebar, (function (prevState) {
            return !prevState;
          }));
    
  };
  React.useEffect((function () {
          if (is_edit_order_open !== undefined && is_edit_order_open === true) {
            Curry._1(updateEditOrderSidebar, (function (prevState) {
                    return !prevState;
                  }));
          }
          
        }), []);
  React.useEffect((function () {
          if (is_editorder_sidebar_open) {
            EventTracker.publishPageview({
                  path: "/v3/order/",
                  title: "edit order sidebar open"
                });
          }
          
        }), [is_editorder_sidebar_open]);
  return React.createElement(React.Fragment, undefined, React.createElement(OrderNavbar.make, {
                  order_details: order_details,
                  tickets: tickets,
                  is_live: true,
                  toggleEditOrderSidebar: toggleEditOrderSidebar,
                  scheduled_order_data: scheduled_order_data
                }), match$1[0], React.createElement(EditOrderContainer.make, {
                  crn: order_crn,
                  order: order_details,
                  user: user,
                  is_editorder_sidebar_open: is_editorder_sidebar_open,
                  toggleEditOrderSidebar: toggleEditOrderSidebar,
                  openSnackbar: match$1[1]
                }), React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "c-order-dashboard"
                }, React.createElement(NLOrderLeftSection.make, {
                      order_crn: order_crn,
                      order: order_details,
                      order_fare: order_fare,
                      load_assist_info: load_assist_info
                    }), React.createElement(NLOrderRightSection.make, {
                      order_id: order_details._0.order_id,
                      order_crn: order_crn,
                      user: user
                    })));
}

var make = OutboundOrderDashboardCmp;

export {
  getOrderId ,
  make ,
  
}
/* react Not a pure module */
